module.exports = __webpack_public_path__ + "df38bd98b5283f3ea5fe46f8a7b72485.pdf";